import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegisterNewGoodsService {
  private httpOptions = {
    headers: new HttpHeaders({
      'contet-type': 'multipart/form-data',
    })
  };

  constructor(
    private http: HttpClient
  ) { }

  public uploadNewGoodsList(file: FormData) {
    return this.http.post(environment.apiEndPoint + 'api/register-new-goods/upload-list', file, this.httpOptions) as Observable<any>;
  }

  public downloadIntageGoodsList(organization: string) {
    const httpOptions: any = {
      responseType: 'blob',
      headers: new HttpHeaders({
        'contet-type': 'application/octet-stream',
      }),

      params: { 'organization': organization }
    };
    return this.http.get(environment.apiEndPoint + 'api/register-new-goods/download-intage-list', httpOptions) as Observable<any>;
  }

  public downloadGoodsList(fileName: string) {
    const httpOptions: any = {
      responseType: 'blob',
      headers: new HttpHeaders({
        'contet-type': 'application/octet-stream',
      }),
      params: {
        'fileName': fileName
      }
    };
    return this.http.get(environment.apiEndPoint + 'api/register-new-goods/download-list', httpOptions) as Observable<any>;
  }
}
